export default "__VITE_ASSET__bd137c7d__"